module.exports = __webpack_public_path__ + "static/media/Lucius Malfoy 2.efe60ba8.jpg";